import { Component, OnInit, SecurityContext } from '@angular/core';
import { UserService } from '../../services/user.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss']
})
export class AdminDashboardComponent implements OnInit {
  actions = [
    {
      label: 'Go',
      method: this.refreshNtirpConfig.bind(this),
      response: '' as SafeHtml | string,
      title: 'Rebuild Config Files',
      description: 'Regenerate NTRIP Configuration Files using data from the database.'
    },
    {
      label: 'Go',
      method: this.rehashNtirp.bind(this),
      response: '' as SafeHtml | string,
      title: 'Apply Config Files',
      description: 'Apply the settings from the NTRIP Config files, make them take effect on the NTRIP Caster right away. This process will not interrupt the current NTRIP connections.'
    },
    {
      label: 'Go',
      method: this.resyncNtirp.bind(this),
      response: '' as SafeHtml | string,
      title: 'Restart NTRIP Engine (Service will be interrupted for 20 seconds)',
      description: 'Restart the NTRIP Caster Engine. All connections will be disconnected, and the NTRIP engine will be reset. The entire NTRIP caster will be down for approximately 20 seconds. Exercise caution when executing this command. '
    }
  ];

  constructor(private userService: UserService, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
  }

  refreshNtirpConfig(): void {
    this.userService.refreshNtirpConfig().subscribe({
      next: (response) => {
        this.actions[0].response = this.sanitizeHtml(response.body.message);
      },
      error: (error) => {
        this.actions[0].response = this.sanitizeHtml('Error refreshing NTRIP config: ' + error.message);
      }
    });
  }

  rehashNtirp(): void {
    this.userService.rehashNtrip().subscribe({
      next: (response) => {
        this.actions[1].response = this.removeHyperlinks(response.message);
      },
      error: (error) => {
        this.actions[1].response = 'Error rehash NTIRP: ' + error.message;
      }
    });
  }

  resyncNtirp(): void {
    this.userService.resyncNtrip().subscribe({
      next: (response) => {
        this.actions[2].response = this.removeHyperlinks(response.message);
      },
      error: (error) => {
        this.actions[2].response = 'Error restart NTIRP: ' + error.message;
      }
    });
  }

  private sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  removeHyperlinks(htmlContent: string): string {
    const parts = htmlContent.split('<hr>');
    const contentAfterHr = parts.length > 1 ? parts[1] : '';
    return this.sanitizer.sanitize(SecurityContext.HTML, contentAfterHr) || '';
  }
}
